import styled from '@emotion/styled';
import type { FC } from 'react';
import { FormControl, InputGroup, type InputGroupProps } from 'react-bootstrap';
import { IconFail, IconSearch } from '../../Icon';
import { Center } from '../MetaComponent';
import { PopoverHint } from '../PopoverHint';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  size?: InputGroupProps['size'];
  clearable?: boolean;
  additionalInfo?: string;
}

export const SearchBar: FC<Props> = ({
  value,
  onChange,
  placeholder = 'Search...',
  clearable = true,
  additionalInfo,
  size = 'sm',
}) => {
  return (
    <StyledSearchBar>
      <InputGroup size={size}>
        <FormControl
          placeholder={placeholder}
          value={value}
          onChange={({ target }) => onChange(target.value)}
        />
        {clearable && value !== '' && (
          <ClearButton size={size} onClick={() => onChange('')}>
            <IconFail />
          </ClearButton>
        )}
        <InputGroup.Append>
          <InputGroup.Text id="basic-addon1">
            <IconSearch />
          </InputGroup.Text>
        </InputGroup.Append>
      </InputGroup>
      {additionalInfo && (
        <StyledFormGroupHint>
          <PopoverHint>{additionalInfo}</PopoverHint>
        </StyledFormGroupHint>
      )}
    </StyledSearchBar>
  );
};

const StyledSearchBar = styled.div`
  display: flex;
`;

const ClearButton = styled(Center)<{ size: InputGroupProps['size'] }>`
  position: absolute;
  z-index: 3;
  right: ${({ size }) => (size === 'sm' ? '35px' : '60px')};
  height: 100%;
  color: darkgray;
  cursor: pointer;

  svg {
    height: 70%;
  }
`;

const StyledFormGroupHint = styled.div`
  padding: 2px;
`;
